import { VerificationQuestion } from "./verification-question";

export class VerificationResponseModel {
  public examQuestions: VerificationQuestion[];
  public otpAllowed: boolean;
  public status: number;
}
